import Vue from 'vue'
import Router from 'vue-router'
import store from '@/vuex/store'
import Home from '@/components/Home'
import Solicitacoes from '@/components/solicitacao/ListaSolicitacoesFornecedores'
import Reembolso from '@/components/solicitacao/colaborador/Reembolso'
import Adiantamento from '@/components/solicitacao/colaborador/Adiantamento'
import PrestacaoDeConta from '@/components/solicitacao/colaborador/PrestacaoDeConta'
import PagamentoDeFornecedores from '@/components/solicitacao/fornecedor/PagamentoDeFornecedores'
import Login from '@/components/autenticacao/Login'
import Compra from '@/components/compra/Compra'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/solicitacoes',
      name: 'solicitacoes',
      component: Solicitacoes,
      meta: {
        requerAutenticacao: true
      }
    },
    {
      path: '/pedidos/reembolsos',
      name: 'reembolso',
      component: Reembolso
    },
    {
      path: '/pedidos/reembolsos/:id',
      name: 'reembolso',
      component: Reembolso
    },
    {
      path: '/pedidos/adiantamentos',
      name: 'adiantamento',
      component: Adiantamento
    },
    {
      path: '/pedidos/adiantamentos/:id',
      name: 'adiantamentoComId',
      component: Adiantamento
    },
    {
      path: '/pedidos/prestarcontas',
      name: 'prestacaoDeContas',
      component: PrestacaoDeConta
    },
    {
      path: '/pedidos/prestarcontas/:id',
      name: 'prestacaoDeContasComId',
      component: PrestacaoDeConta
    },


    {
      path: '/pagamentos/fornecedores',
      component: PagamentoDeFornecedores,
      name: 'pagamentoDeFornecedores'
    },
    {
      path: '/pagamentos/fornecedores/:id',
      component: PagamentoDeFornecedores,
      name: 'pagamentoDeFornecedoresComId'
    },
    {
      path: '/usuarios',
      name: 'usuarios',
      meta: {
        requerAutenticacao: true
      },
      component: () => import('./components/usuario/Usuarios.vue')
    },
    {
      path: '/contas',
      name: 'Contas',
      meta: {
        requerAutenticacao: true
      },
      component: () => import('./components/contaGerencial/ContasGerenciais.vue')
    },
    {
      path: '/fornecedores',
      name: 'Fornecedores',
      component: () => import('./components/fornecedor/Fornecedores.vue')
    },
    {
      path: '/centrosDeCusto',
      name: 'centrosDeCusto',
      meta: {
        requerAutenticacao: true
      },
      component: () => import('./components/centroDeCusto/CentroDeCusto.vue')
    },
    {
      path: '/compras',
      name: 'compras',
      meta: {
        requerAutenticacao: true
      },
      component: Compra
    }
  ]
})

router.beforeEach((to, from, next) => {
  let usuarioOnline = localStorage.hasOwnProperty('usuarioLogado');
  if (usuarioOnline) {
    store.commit('set', {
      itemName: 'loggedUser',
      content: JSON.parse(localStorage.getItem('usuarioLogado'))
    })
    store.commit('set', {
      itemName: 'isAuth',
      content: true
    });
  } else {
    store.commit('set', {
      itemName: 'loggedUser',
      content: {}
    })
    store.commit('set', {
      itemName: 'isAuth',
      content: false
    });
  }
  let requerAutenticacao = to.matched.some(record => record.meta.requerAutenticacao);
  let usuarioAutenticado = usuarioTemPermissaoDeAcesso(to);

  if (to.fullPath != '/login' && usuarioOnline) {
    if (requerAutenticacao) {
      if (usuarioAutenticado) return next();
      else return next('/home')
    } else {
      if (to.name != null) next()
      else {
        next({
          path: '/home'
        })
      }
    }
  }

  if (to.fullPath == '/login') {
    if (usuarioOnline == false) next();
    else next({
      path: '/home'
    })
  }

  if (to.name == null) {
    if (usuarioOnline) next('/home')
    else next({
      path: '/login'
    })
  }

  if (!usuarioOnline && to.fullPath != '/login') {
    next({
      path: '/login'
    })
  }

  next();
})


function usuarioTemPermissaoDeAcesso(rotaAtual) {
  let usuarioOnline = localStorage.hasOwnProperty('usuarioLogado');
  let autorizado = false;
  if (usuarioOnline) {
    let storageUser = JSON.parse(localStorage.getItem('usuarioLogado'));
    let papeisUser = storageUser.papeis.map(itemArray => itemArray.nome);

    let rotasAcessadasApenasPorAdmins = [
      {
        name: 'usuarios',
        autorizados: ['ADMIN']
      },
      {
        name: 'compras',
        autorizados: ['ADMIN_FORNECEDOR', 'ADMIN']
      },
      {
        name: 'centrosDeCusto',
        autorizados: ['ADMIN_CENTROS_DE_CUSTO', 'ADMIN']
      },
      {
        name: 'Contas',
        autorizados: ['ADMIN_CONTAS_GERENCIAIS', 'ADMIN']
      },
      {
        name: 'solicitacoes',
        autorizados: ['APROVADOR', 'APROVADOR_CONTABILIDADE', 'APROVADOR_FINANCEIRO', 'APROVADOR_FINANCEIRO_EXCECAO', "SOLICITANTE", "PROCURADOR"]
      }
    ]

    rotasAcessadasApenasPorAdmins = rotasAcessadasApenasPorAdmins.filter(x => x.name == rotaAtual.name)
    for (let i = 0; i < rotasAcessadasApenasPorAdmins.length; i++) {
      const rota = rotasAcessadasApenasPorAdmins[i];
      for (let j = 0; j < rota.autorizados.length; j++) {
        const papel = rota.autorizados[j];
        if (papeisUser.indexOf(papel) != -1) {
          autorizado = true;
          break;
        }
      }
    }

  }
  return autorizado;
}

export { router as default }